/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const card = {
    position: 'relative',
    py: 6,
    px: 4,
    backgroundColor: 'white',
    rounded: [0, 0, 'base'],
    boxShadow: 'base'
}

const cardBordered = {
    ...card,
    px: [4, 4, 5, 6],
    border: '1px solid',
    borderColor: 'gray.50'
}

const accountCard = {
    position: 'relative',
    px: [16, 16, 16, 50],
    py: 24,
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'borderGray'
}

const checkoutCard = {
    position: 'relative',
    px: [16, 16, 16, 48],
    py: [16, 16, 16, 32],
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'borderGray'
}

const pageBase = {
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto'
}

export default {
    card,
    cardBordered,
    accountCard,
    checkoutCard,

    ccIcon: {
        width: '34px',
        height: '22px'
    },

    page: {
        ...pageBase,
        px: 0,
        paddingTop: 0,
        paddingBottom: 32
    },

    userpage: {
        ...pageBase,
        bg: 'whiteSmoke',
        px: 16,
        paddingTop: [40, 40, 40, 48],
        paddingBottom: 56
    },

    accountpage: {
        ...pageBase,
        bg: 'whiteSmoke',
        px: [0, 0, 0, 40],
        paddingTop: [0, 0, 0, 48],
        paddingBottom: 56
    }
}
